'use client';
import { memo } from 'react';
import { Button } from '@chakra-ui/react';

import { goTo, ym } from 'shared/lib';

import { FORM_ID } from 'constants/global';

const ButtonGoTo = ({
  children = null,
  btnText = 'Оставить заявку',
  enableGoTo = true,
  elementToGo = FORM_ID,
  ymName = null,
  onBtnClick = null,
  ...props
}) => (
  <Button
    onClick={() => {
      enableGoTo && goTo(elementToGo);
      ymName && ym(ymName);
      onBtnClick && onBtnClick();
    }}
    {...props}
  >
    {children}
    {btnText}
  </Button>
);

export default memo(ButtonGoTo);
